// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"df67293e","59":"62ece7ff","60":"d097b996","91":"b7636a2e","97":"4fbe1803","116":"fd3e7ef9","364":"5932a7f2","445":"2cffc62c","477":"ec060fc6","478":"80b1e568","512":"0e2018de"}[chunkId] + ".chunk.js";
};